import { render, staticRenderFns } from "./TedsEveryoneLogo.vue?vue&type=template&id=241cf85a&"
import script from "./TedsEveryoneLogo.vue?vue&type=script&lang=ts&"
export * from "./TedsEveryoneLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports